export default {
  type: 'object',
  properties: {
    id: { type: 'number' },
    code: { title: 'Nazwa', type: 'string', fieldRequired: true },
    value: {
      type: 'object',
      properties: {
        number: {
          disabled: '!$root.code || $root.code.indexOf("NUMBER") < 0',
          type: 'string',
          calc: { func: 'this.numbers[this.numbers.length - 1].number', when: '!!this.numbers.length' }
        },
        numbers: {
          disabled: '!$root.code || $root.code.indexOf("NUMBER") < 0',
          title: 'Wartości',
          type: 'array',
          items: {
            type: 'object',
            properties: {
              number: {
                title: ['if (this.added) {', 'return "Nowa wartość";', '}', 'return "Wartość";'],
                type: 'string',
                fieldRequided: true
              },
              added: { type: 'boolean', computed: true }
            }
          }
        },
        date: {
          disabled: '!$root.code || $root.code.indexOf("DATE") < 0',
          title: 'Wartość',
          type: 'string',
          fieldRequided: false,
          format: 'date',
          calc: {
            func: [
              'var timestamps = this.dates.map(function (date) { return new Date(date.date).getTime();}).map(function (val) { return val > 0 ? val : 0;});',
              'var index = timestamps.indexOf(Math.max.apply(Math, timestamps));',
              'return this.dates[index] && this.dates[index].date'
            ],
            when: '!!this.dates.length'
          }
        },
        dates: {
          disabled: '!$root.code || $root.code.indexOf("DATE") < 0',
          title: 'Wartości',
          type: 'array',
          items: {
            type: 'object',
            properties: {
              date: {
                title: ['if (this.added) {', 'return "Nowa wartość";', '}', 'return "Wartość";'],
                type: 'string',
                format: 'date',
                fieldRequided: true
              },
              added: {
                type: 'boolean',
                computed: true
              }
            }
          }
        },
        bool: {
          disabled: '!$root.code || !$root.code.startsWith("IS_")',
          title: 'Wartość',
          type: 'boolean'
        }
      }
    },
    documentId: {
      title: 'Identyfikator dokumentu',
      type: 'number',
      fieldRequired: true
    }
  }
};
